export default function OurHappyClients() {
  return (
    <div className="small_basket our_happy_clients">
      <div className="our_happy_clients_inner">
        <h2>Our Happy Clients</h2>
        <div className="our_happy_clients_img">
          <img src="./images/user_photo_icon_blur.png" />
        </div>
        <div className="our_happy_clients_text">
          <p>
            I am happy of the services that I got from Socca ReactApp. They
            created for me a good web app that helped me solve my business
            problems
          </p>
          <span className="span_style_type3">Diana Kerubo</span>
          <span>Business magnate</span>
        </div>
      </div>
    </div>
  );
}
